// removed by extract-text-webpack-plugin
module.exports = {"summary":"TechniciansListPage__summary___1F05I","headerContainer":"TechniciansListPage__headerContainer___3Uzq-","sortableColumn":"TechniciansListPage__sortableColumn___1fmI5"};


//////////////////
// WEBPACK FOOTER
// ./study_reviewer/src/pages/TechniciansListPage.css
// module id = 1224
// module chunks = 0